<template>
  <div class="row Confirmation">
    <div class="col">
      <div class="Title">前往結帳視同上述聲明皆同意</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Confirmation",
}
</script>

<style lang="scss" scoped>
.Confirmation {
  padding-bottom: 80px !important;
  > .col {
    > .Title {
      margin-bottom: 10px;
      font-size: 20px;
      font-weight: 900;
      text-align: center;
      color: #0066FFAA;
      text-shadow: 1px 1px 0 #000000;
    }
  }
}
</style>